import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { HiCurrencyDollar } from "react-icons/hi";
const EconomicInformationCompany = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  return (
    <div className={styles.informacionEconomica} id="economica">
      <div className={styles.sectionTitle2}>
        <h2 className={styles.sectionTitleH2}>Información Económica</h2>
        <IconAnimation className={styles.iconAlert} />
      </div>
      {!company || !company.EconomicInformationCompany ? (
        <NotReportViewData
          title="Información Económica"
          Icon={HiCurrencyDollar}
        />
      ) : (
        <>
          <label className={styles.inputLabel}>
            Monto transaccional anual:
            <input
              className={styles.inputField}
              type="number"
              name="IncomeOfLegalPerson"
              value={
                company.EconomicInformationCompany.IncomeOfLegalPerson || ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Total de endeudamiento del sistema financiero:
            <input
              className={styles.inputField}
              type="number"
              name="total_indebtedness_of_the_financial_system"
              value={
                company.EconomicInformationCompany
                  .total_indebtedness_of_the_financial_system || ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Total de compromiso mensual sistema financiero:
            <input
              className={styles.inputField}
              type="number"
              name="total_monthly_commitment_of_the_financial_system"
              value={
                company.EconomicInformationCompany
                  .total_monthly_commitment_of_the_financial_system || ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.inputLabel}>
            Situación vigente ante Bcra:
            <input
              className={styles.inputField}
              type="text"
              name="current_status_with_BCRA"
              value={
                company.EconomicInformationCompany.current_status_with_BCRA ||
                ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
        </>
      )}
    </div>
  );
};

export default EconomicInformationCompany;
